<template>
  <v-container v-if="_.isEmpty(parts) && loadingParts">
    <v-row justify="center">
      <v-progress-circular
        indeterminate
      />
    </v-row>
  </v-container>
  <core-main-table
    v-else
    v-bind="$attrs"
    :headers="partsTableHeaders"
    :items="parts"
    class="my-4 ml-4"
    hide-default-footer
    rights-group="rfq"
  >
    <template #item.PriceMOQ="{ item }">
      <core-table-unit-pricing :item="item" />
    </template>
  </core-main-table>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'RfqPartsTable',
  props: {
    rfqId: {
      type: String,
    },
  },

  computed: {
    ...mapGetters('parts', { findParts: 'find' }),
    ...mapState('parts', { loadingParts: 'isFindPending' }),
    ...mapGetters('materials', { getMaterials: 'get' }),

    parts() {
      const partsFromStore = this.findParts({
        query: {
          EstimateID: this.rfqId,
        },
      }).data;
      // if (partsFromStore.length < 1) {
      //   this.$emit('fetchParts');
      // }
      return partsFromStore;
    },

    partsTableHeaders() {
      return [
        {
          text: 'Client part #',
          value: 'CustItemName',
          sortable: false,
        },
        {
          text: 'Description',
          value: 'Description',
          sortable: false,
        },
        {
          text: 'Material',
          value: 'MaterialSeriesStr',
          sortable: false,
        },
        {
          text: 'Thickness',
          value: 'MaterialThicknessStr',
          sortable: false,
        },
        {
          text: 'Finish',
          value: 'MaterialFinishStr',
          sortable: false,
        },
        {
          text: 'Price/MOQ',
          value: 'PriceMOQ',
          sortable: false,
        },
        {
          text: '',
          value: 'data-table-menu',
          items: [
          ],
        },
      ];
    },

    // Computed property means this Math.random will only evaluate once
    getPartName() {
      return `/img/placeholder_item_${Math.floor(Math.random() * 3) + 1}.png`;
    },
  },

  methods: {
    formatDate(date) {
      if (!moment(date).isValid()) {
        return '';
      }
      return moment(date).format('YYYY-MM-DD');
    },

    getMaterialDescription(materialID) {
      const mat = this.getMaterials(materialID);
      return mat ? mat.Description : '';
    },
  },
};
</script>

<style scoped>

</style>
